import { useNavigate } from "react-router-dom";
import { GAMES, CATEGORIES, HUB_BG, MASCOT } from "@/lib/games";
import { useActiveChild } from "@/lib/useActiveChild";

export default function PlayHub() {
  const child = useActiveChild();
  const navigate = useNavigate();

  if (!child) {
    return (
      <div className="kid-mode min-h-screen flex items-center justify-center">
        <button onClick={() => navigate("/play")} className="kid-btn bg-sky-500 text-white">
          Escolher personagem
        </button>
      </div>
    );
  }

  return (
    <div className="kid-mode min-h-screen relative" data-testid="play-hub">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HUB_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-sky-100/30 via-sky-100/40 to-sky-100/70" />

      <header className="relative z-10 flex items-center justify-between p-4 md:p-6">
        <button
          onClick={() => navigate("/play")}
          className="kid-btn bg-white text-slate-700 text-sm"
          data-testid="hub-back"
        >
          ← Trocar
        </button>
        <div className="flex items-center gap-3 bg-white/80 backdrop-blur rounded-full px-4 py-2 shadow">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-2xl"
            style={{ background: child.avatar_color }}
          >
            {child.avatar_emoji}
          </div>
          <div>
            <div className="font-bold text-slate-800 leading-tight">{child.name}</div>
            <div className="text-xs text-slate-500">🪙 {child.coins || 0} moedas</div>
          </div>
        </div>
      </header>

      <main className="relative z-10 px-4 md:px-12 pb-16">
        <div className="text-center mt-4 md:mt-6">
          <h1 className="text-4xl md:text-6xl text-white drop-shadow-[0_4px_0_rgba(0,0,0,0.25)]">
            Ilha das Descobertas
          </h1>
          <p className="text-white/95 text-lg mt-2 drop-shadow">
            Escolha um portal mágico para começar uma aventura!
          </p>
        </div>

        <div className="max-w-6xl mx-auto mt-10 space-y-10">
          {CATEGORIES.map((cat) => {
            const items = GAMES.filter((g) => g.category === cat);
            if (items.length === 0) return null;
            return (
              <section key={cat} data-testid={`hub-cat-${cat}`}>
                <h2 className="text-2xl md:text-3xl text-white drop-shadow mb-4 pl-1">
                  {cat}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {items.map((g, i) => (
                    <button
                      key={g.id}
                      onClick={() => navigate(g.route)}
                      className="kid-card text-left group transition hover:-translate-y-1 stagger-fade relative"
                      style={{ animationDelay: `${i * 60}ms` }}
                      data-testid={`hub-game-${g.id}`}
                    >
                      {g.forAdult && (
                        <div className="absolute top-3 right-3 bg-slate-800 text-white text-xs px-2 py-1 rounded-full">
                          📋 Adulto
                        </div>
                      )}
                      <div
                        className="w-full aspect-[16/9] rounded-2xl bg-cover bg-center mb-4 relative overflow-hidden flex items-center justify-center"
                        style={
                          g.bgGradient
                            ? { background: g.bgGradient }
                            : { backgroundImage: `url(${g.bg})` }
                        }
                      >
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                        {g.bgGradient && (
                          <div className="relative text-7xl drop-shadow-lg">{g.emoji}</div>
                        )}
                        <div
                          className="absolute top-3 left-3 w-12 h-12 rounded-full flex items-center justify-center text-2xl shadow-lg"
                          style={{ background: g.color }}
                        >
                          {g.emoji}
                        </div>
                      </div>
                      <h3 className="text-xl mb-1">{g.name}</h3>
                      <div className="text-sm font-semibold" style={{ color: g.color }}>
                        {g.short}
                      </div>
                      <p className="text-sm text-slate-600 mt-1">{g.description}</p>
                    </button>
                  ))}
                </div>
              </section>
            );
          })}
        </div>

        <img
          src={MASCOT}
          alt="Mascote"
          className="hidden md:block fixed bottom-4 right-4 w-28 h-28 object-contain float-soft z-20"
        />
      </main>
    </div>
  );
}
